import React from "react";
import { PodcastValidationError } from "src/types/coaching/podcast";

export interface PodcastContextProps {
  id?: string;
  validationError?: PodcastValidationError;
  showValidationErrorDialog?: boolean;
  
  // eslint-disable-next-line no-unused-vars
  setShowValidationErrorDialog?: (show: boolean) => void;
  
  // eslint-disable-next-line no-unused-vars
  gotoError?(error?: PodcastValidationError): void;
}

export const PodcastContext = React.createContext<PodcastContextProps>({
  id: undefined,
  validationError: undefined,
  gotoError: undefined,
});
